export default __webpack_public_path__ + "static/media/wavesLight.6b0d9567.svg";